'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InterlibraryLoansIcon;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function InterlibraryLoansIcon(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
      'aria-hidden': true,
      className: (0, _classnames2.default)('icon-svg-interlibrary-loans-icon', className),
      width: width,
      height: height,
      viewBox: '0 0 48 48' },
    _react2.default.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { fill: '#FFF', d: 'M0 0h48v48H0z' }),
      _react2.default.createElement('path', { fill: color, d: 'M8.857 16.922c0-.094.046-.187.139-.281.092-.094.184-.141.277-.141h14.669c.092 0 .185.047.277.14.092.095.138.188.138.282v1.406c0 .094-.046.188-.138.28-.092.095-.185.142-.277.142H9.273c-.093 0-.185-.047-.277-.141-.093-.093-.139-.187-.139-.281v-1.406zm0-4.5c0-.094.046-.187.139-.281.092-.094.184-.141.277-.141h14.669c.092 0 .185.047.277.14.092.095.138.188.138.282v1.406c0 .094-.046.188-.138.28-.092.095-.185.142-.277.142H9.273c-.093 0-.185-.047-.277-.141-.093-.093-.139-.187-.139-.281v-1.406zM21.525 34.5H6.643c-.6 0-1.119-.223-1.557-.668a2.179 2.179 0 0 1-.657-1.582c0-.61.219-1.137.657-1.582.438-.445.957-.668 1.557-.668h15.429A14.51 14.51 0 0 1 31 20.404V4.688c0-.47-.162-.868-.484-1.196A1.59 1.59 0 0 0 29.339 3H6.643c-1.845 0-3.414.656-4.705 1.969C.646 6.28 0 7.875 0 9.749v22.5c0 1.876.646 3.47 1.938 4.782C3.229 38.344 4.798 39 6.643 39h15.761a14.41 14.41 0 0 1-.879-4.5z' }),
      _react2.default.createElement('path', { fill: color, d: 'M48 34a11.64 11.64 0 0 1-1.62 6A12.126 12.126 0 0 1 42 44.379 11.64 11.64 0 0 1 36 46a11.64 11.64 0 0 1-6-1.621A12.126 12.126 0 0 1 25.621 40a11.64 11.64 0 0 1-1.62-6c0-2.161.54-4.161 1.62-6a12.126 12.126 0 0 1 4.38-4.379A11.64 11.64 0 0 1 36 22c2.16 0 4.16.541 6 1.621A12.126 12.126 0 0 1 46.378 28 11.64 11.64 0 0 1 48 34zm-21.677 0c0 1.742.435 3.355 1.306 4.839a9.756 9.756 0 0 0 3.532 3.532 9.391 9.391 0 0 0 4.84 1.306 9.391 9.391 0 0 0 4.838-1.306 9.756 9.756 0 0 0 3.532-3.532A9.391 9.391 0 0 0 45.677 34a9.391 9.391 0 0 0-1.306-4.839 9.756 9.756 0 0 0-3.532-3.532A9.391 9.391 0 0 0 36 24.323a9.391 9.391 0 0 0-4.839 1.306 9.756 9.756 0 0 0-3.532 3.532A9.391 9.391 0 0 0 26.323 34z' }),
      _react2.default.createElement('path', { fill: color, d: 'M32.136 32.717v1.102c0 .16-.052.295-.155.407a.498.498 0 0 1-.379.168.498.498 0 0 1-.378-.168l-1.915-2.06a.576.576 0 0 1-.156-.407c0-.16.052-.295.156-.407l1.915-2.06a.498.498 0 0 1 .378-.167c.149 0 .275.055.379.167a.576.576 0 0 1 .155.407v1.102h6.724c.074 0 .137.028.189.084a.288.288 0 0 1 .078.203v1.342c0 .08-.026.147-.078.203a.249.249 0 0 1-.19.084h-6.723zm7.637 4.905H33.05a.249.249 0 0 1-.189-.084.288.288 0 0 1-.078-.203v-1.342c0-.08.026-.147.078-.203a.249.249 0 0 1 .19-.084h6.722v-1.102c0-.16.052-.295.156-.407a.498.498 0 0 1 .379-.167c.148 0 .274.055.378.167l1.915 2.06a.576.576 0 0 1 .156.407c0 .16-.052.295-.156.407l-1.915 2.06a.498.498 0 0 1-.378.168.498.498 0 0 1-.379-.168.576.576 0 0 1-.156-.407v-1.102z' })
    )
  );
}

InterlibraryLoansIcon.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/InterlibraryLoansIcon/InterlibraryLoansIcon.js
// module id = 257
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16